import * as React from 'react'

// general imports
import { IconPropsType } from '../types'

function ArrowRightIcon({ className }: IconPropsType) {
  return (
    <svg
      width='30'
      height='30'
      className={className}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_15842_4363)'>
        <path
          d='M10.7383 20.7375L16.4633 15L10.7383 9.2625L12.5008 7.5L20.0008 15L12.5008 22.5L10.7383 20.7375Z'
          fill='#535353'
        />
      </g>
      <defs>
        <clipPath id='clip0_15842_4363'>
          <rect width='30' height='30' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowRightIcon
